import { createApi } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import {
  CreatePostRequestPayload,
  EditPostRequestPayload,
  Post,
  SetPostSubscriptionRequestPayload,
  SetPostUnsubscriptionRequestPayload,
} from '../../types'

export type GetPostsQueryPaylod = {
  search?: string
  filter?: string
}

export const postsApi = createApi({
  reducerPath: 'postsApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Posts'],
  endpoints: (builder) => ({
    getPosts: builder.query<Post[], GetPostsQueryPaylod>({
      query: (queryParams: GetPostsQueryPaylod) => ({
        url: generateUrl(queryParams),
      }),
      providesTags: ['Posts'],
    }),
    getPostById: builder.query<Post, string>({
      query: (id: string) => ({
        url: `${CONSTANTS.API.POSTS}/${id}`,
      }),
      providesTags: ['Posts'],
    }),
    createPost: builder.mutation({
      query: (payload: CreatePostRequestPayload) => ({
        url: CONSTANTS.API.POSTS,
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      invalidatesTags: ['Posts'],
    }),
    editPost: builder.mutation({
      query: (payload: EditPostRequestPayload) => {
        return {
          url: `${CONSTANTS.API.POSTS}/${payload.id}`,
          method: 'PATCH',
          body: payload,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
    }),
    subscribeUserToPost: builder.mutation({
      query: (payload: SetPostSubscriptionRequestPayload) => ({
        url: `${CONSTANTS.API.POSTS}/${payload.post_id}/subscribed`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Posts'],
    }),
    unsubscribeUserFromPost: builder.mutation({
      query: (payload: SetPostUnsubscriptionRequestPayload) => ({
        url: `${CONSTANTS.API.POSTS}/${payload.post_id}/unsubscribed`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Posts'],
    }),
    deletePost: builder.mutation({
      query: (id: string) => ({
        url: `${CONSTANTS.API.POSTS}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Posts']
    })
  }),
})

const generateUrl = (queryParams: GetPostsQueryPaylod) => {
  let query = new URLSearchParams(queryParams).toString()
  query = query.replace('undefined', '')
  return `${CONSTANTS.API.POSTS}${query.length > 0 ? '?' : ''}${query}`
}

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPostsQuery,
  useGetPostByIdQuery,
  useCreatePostMutation,
  useEditPostMutation,
  useSubscribeUserToPostMutation,
  useUnsubscribeUserFromPostMutation,
  useDeletePostMutation
} = postsApi
